module.exports = __webpack_public_path__ + "img/x-yuki-icon.6c7e0f95.png";